// ====================== PC端时间线交互 ======================
document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector("[data-timeline-slider]");
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.style.cursor = "grabbing";
    // 滑动开始时禁止全局选中
    document.body.style.userSelect = "none";
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.style.cursor = "grab";
    document.body.style.userSelect = "";
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.style.cursor = "grab";
    document.body.style.userSelect = "";
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
});

// ====================== 移动端时间线交互 ======================
document.addEventListener("DOMContentLoaded", () => {
  // 移动端折叠/展开
  const mobileItems = document.querySelectorAll("[data-mobile-item]");
  const loadMoreBtn = document.querySelector("[data-loadmore]");
  const hiddenItems = document.querySelectorAll(".timeline-item-hidden");

  // 点击切换展开/关闭
  mobileItems.forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("active");
    });
  });

  // 加载更多【展开/收缩切换】逻辑
  if (loadMoreBtn && hiddenItems.length > 0) {
    loadMoreBtn.addEventListener("click", () => {
      // 切换隐藏项的显示/隐藏
      hiddenItems.forEach((item) => {
        item.classList.toggle("show");
      });

      // 切换图标旋转类
      loadMoreBtn.classList.toggle("rotate");
    });
  }
});
